@if (params?.displayName && (!params?.column?.getColId())) {
  <span>{{ params.displayName }}</span>
}
@if (params?.displayName && params?.column?.getColId() && params?.additionalData?.length > 0 && params?.column.getColDef().field !== 'isSelected') {
  <div class="header-div" (mousedown)="onHeaderMouseDown()" (mouseup)="onHeaderMouseUp()">
    <app-shared-button [id]="getButtonUniqueID" [fill]="false" [colour]="'clear'"
                       (buttonClicked)="onButtonClick($event)">
      <div class="menu-item-container "
           [ngClass]="params.column.getColDef()?.type && params.column.getColDef().type.includes('alignRight') ? 'align-right' : 'align-left'">
        <span [matTooltip]="'Open ' + params.displayName + ' Menu'" class="display-name">{{ params.displayName }}</span>
      </div>
    </app-shared-button>
    <div class="icons-span">
      @if (sortIcon?.[storeId]?.[params.column.getColDef().field]) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.yellow"
          [icon]="sortIcon[storeId][params.column.getColDef().field]">
        </app-display-icon>
      }
      @if (editingColumns?.[storeId]?.[params.column.getColDef().field]) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.red"
          [icon]="icons.pencil">
        </app-display-icon>
      }</div>
  </div>

  <app-shared-popover
    #columnMenu
    [dismissOnSelect]="true"
    [ariaLabel]="params.displayName + ' menu'">
    <div class="app-content">
      <div class="list-container">
        @for (menuItem of params.additionalData; track $index) {
          @if (isButtonVisible(menuItem)) {
            <div class="list-item"
                 (click)="onMenuItemClick($event, menuItem)"
                 [attr.data-shared-popover-keep-open]="menuItem.options?.length ? true : null"
                 [id]="menuItem.callbackParams.colId + menuItem.callbackParams.action">
              <div class="menu-item-container">
                <app-display-icon
                  [border]="false"
                  [colour]="menuItem.colour"
                  [icon]="menuItem.icon"
                  [tooltip]="menuItem.displayName + ' ' + params.displayName">
                </app-display-icon>
                <span>{{ menuItem.displayName }}</span>
              </div>
            </div>
          }
          @if (menuItem.options?.length > 0 && isButtonVisible(menuItem)) {
            <app-shared-popover
              [trigger]="menuItem.callbackParams.colId + menuItem.callbackParams.action"
              [dismissOnSelect]="true"
              [showBackdrop]="false"
              side="end"
              alignment="start"
              [ariaLabel]="menuItem.displayName + ' submenu'">
              <div class="app-content">
                <div class="list-container">
                  @for (opt of menuItem.options; track opt.callbackParams.colId + opt.callbackParams.action) {
                    @if (isButtonVisible(opt)) {
                      <div class="list-item"
                           (click)="onSubmenuItemClick(opt)"
                           [id]="opt.callbackParams.colId + opt.callbackParams.action">
                        <div class="menu-item-container">
                          <app-display-icon
                            [border]="false"
                            [colour]="opt.colour"
                            [icon]="opt.icon"
                            [tooltip]="opt.displayName + ' ' + params.displayName">
                          </app-display-icon>
                          <span>{{ opt.displayName }}</span>
                        </div>
                      </div>
                    }
                  }
                </div>
              </div>
            </app-shared-popover>
          }
        }
        <ng-container *ngrxLet="(appliedFilterGroup$ | ngrxPush ) as appliedFilter">
          <ng-container *ngrxLet="(queryData$ | ngrxPush)?.filters as filters">
            @if ((appliedFilter?.grid === 'stock-manager' || isNonEmptyObject(filters)) && params.displayName === 'Code') {
              <div class="list-item"
                   (click)="onLockAllStockItemsClick(false)"
                   [id]="params.displayName + '-Lock-All'">
                <div class="menu-item-container">
                  <app-display-icon
                    [border]="false"
                    [colour]="iconColourEnum.white"
                    [icon]="icons.lockClosedOutline"
                    [tooltip]="'Lock All Filtered Stock Items'">
                  </app-display-icon>
                  <span> Disable All Items</span>
                </div>
              </div>
              <div class="list-item"
                   (click)="onLockAllStockItemsClick(true)"
                   [id]="params.displayName + '-Enable-All'">
                <div class="menu-item-container">
                  <app-display-icon
                    [border]="false"
                    [colour]="iconColourEnum.white"
                    [icon]="icons.lockOpenOutline"
                    [tooltip]="'Enable All Filtered Stock Items'">
                  </app-display-icon>
                  <span> Enable All Items</span>
                </div>
              </div>
            }
          </ng-container>
        </ng-container>
      </div>
    </div>
  </app-shared-popover>
} @else if (params?.displayName && params?.column?.getColId() && params?.column.getColDef().field !== 'isSelected') {
  <div class="header-div" (mousedown)="onHeaderMouseDown()" (mouseup)="onHeaderMouseUp()">
    <app-shared-button [id]="getButtonUniqueID" [fill]="false" [colour]="'clear'"
                       (buttonClicked)="onSimpleHeaderClick($event)">
      <div class="menu-item-container "
           [ngClass]="params.column.getColDef()?.type && params.column.getColDef().type.includes('alignRight') ? 'align-right' : 'align-left'">
        <span [matTooltip]="tooltipText[params.column.getColDef().field]"
              class="display-name">{{ params.displayName }}</span>
      </div>
    </app-shared-button>
    <div class="icons-span">
      @if (params.column.isSortAscending() || params.column.isSortDescending()) {
        <app-display-icon
          [border]="false"
          [colour]="iconColourEnum.white"
          [icon]="params.column.isSortAscending() ? icons.arrowUp : icons.arrowDown">
        </app-display-icon>
      }
    </div>
  </div>

} @else if (params?.column.getColDef().field === 'isSelected') {
  <input type="checkbox" class="indeterminate-checkbox" [indeterminate]="getIndeterminateForPage()"
         [checked]="getSelectedForPage()" (click)="toggleSelection()" />
}
